<template>
  <div>
    <div v-if="$route.name !=='preview' && $route.name !=='submitsuccess' && mode.confirm !== true && poster">
      <ul class="nav" v-if="getCurrentPages(poster.setting_submission_id)">
        <div v-for="(page, index) in getCurrentPages(poster.setting_submission_id)" v-bind:key="index">
          <li class="nav-item" v-if="page.setting_page_type_id === 1">
            <router-link :to="'/poster/' + $route.params.id + '/dynamic/' + page.id" class="nav-link">
              <icon :icon="[page.menu_icon_library, page.menu_icon_name]"/>
              {{ page.menu_name }}
            </router-link>
          </li>
          <li class="nav-item" v-else-if="page.setting_page_type_id === 2">
            <router-link :to="'/poster/' + $route.params.id + '/authors'" class="nav-link">
              <icon :icon="[page.menu_icon_library, page.menu_icon_name]"/>
              {{ page.menu_name }}
            </router-link>
          </li>
          <li class="nav-item" v-else-if="page.setting_page_type_id === 3">
            <router-link :to="'/poster/' + $route.params.id + '/submit'" class="nav-link">
              <icon :icon="[page.menu_icon_library, page.menu_icon_name]"/>
              {{ page.menu_name }}
            </router-link>
          </li>
          <li class="nav-item" v-else-if="page.setting_page_type_id === 4">
            <router-link :to="'/poster/' + $route.params.id + '/payment'" class="nav-link">
              <icon :icon="[page.menu_icon_library, page.menu_icon_name]"/>
              {{ page.menu_name }}
            </router-link>
          </li>
        </div>
      </ul>
      <div class="float-end">
      </div>
    </div>
    <div v-else>
      <ul class="nav">
        <li class="nav-item"><span class="nav-link">&nbsp;</span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'SubmissionSteps',
  computed: {
    ...mapState([
      'poster', 'mode'
    ]),
    ...mapGetters([
      'getCurrentPages'
    ]),
  },
}
</script>
